import React from 'react';

import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';

const EditItemIcon = ({ path, disabled = false, size = 'middle' }) => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <Tooltip title={t('actions.edit')}>
      <Button
        shape="circle"
        type="link"
        icon={<EditOutlined />}
        onClick={() => history.push(path)}
        disabled={disabled}
        size={size}
      />
    </Tooltip>
  );
};

export default EditItemIcon;
